import i18n from '@/i18n'
import { getUser } from '@/store'

// https://stackoverflow.com/a/37511463/1313904

export const removeDiacritics = (str = '') =>
	str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const removePunctuation = (str = '') => str.replace(/\p{P}/gu, '')

export const lowerCase = (str = '') => str.toLocaleLowerCase()

export const normalizeString = (str = '') =>
	lowerCase(removeDiacritics(removePunctuation(str)))

export const lastIndexOfRegex = (str, regex) => {
	const match = str.match(regex)
	return match ? str.lastIndexOf(match.pop()) : -1
}

export const replaceMentions = (messageText) => {
	const re = /\<\@(\d*?|everyone)\>/gi
	return messageText.replace(re, (i, match) => {
		if (match === 'everyone') {
			return '@everyone'
		}
		const user = getUser(match)
		const name = user
			? user.fullname
			: i18n.global.t('model_user_noname', [match])
		return `@${name}`
	})
}
